<template>
  <div class="peer-item-wrapper" :class="screenShare ? 'has-screen-cast' : null">
    <div class="indicators">
      <div class="peer-status-icon cursor-pointer" v-if="videoConsumer" @click="fullScreen">
        <i class="fas fa-expand"></i>
        <md-tooltip md-delay="100">{{$t('account_bar.fullscreen')}}</md-tooltip>
      </div>

      <div class="peer-status-icon cursor-pointer" v-if="!screenShare && audioEnabled" @click="toggleRemoteAudio">
        <i class="fas" :class="!muted ? 'fa-volume-up' : 'fa-volume-mute'"></i>
        <md-tooltip md-delay="100">{{$t('volume_on_off')}}</md-tooltip>
      </div>

      <div class="peer-status-icon" v-if="!audioEnabled && !screenShare">
        <i class="fas fa-microphone-slash"></i>
        <md-tooltip md-delay="100">{{$t('speaker.speaker_microphone_off')}}</md-tooltip>
      </div>

      <div class="peer-status-icon" v-if="!videoConsumer && !screenShare">
        <i class="fas fa-video-slash"></i>
        <md-tooltip md-delay="100">{{$t('speaker.speaker_camera_off')}}</md-tooltip>
      </div>

      <div class="peer-status-icon icon fps-indicator" :class="fps" v-if="fps != null && fps != 'undefined'">
        <i class="fas fa-signal"></i>
        <md-tooltip md-delay="100" v-if="peer.device != null">
          ( {{ peer.device.name || '' }} {{ peer.device.version || '' }} - {{ networkType }} )
        </md-tooltip>
      </div>
    </div>

    <peer-view class="peer-view" :class="screenShare ? 'has-screen-cast' : ''"
               :screenShare="screenShare"
               :myScreenShare="myScreenShare"
               :peer="peer"
               :audio-consumer-id="audioConsumer ? audioConsumer.id : null"
               :video-consumer-id="videoConsumer ? videoConsumer.id : null"
               :audio-rtp-parameters="audioConsumer ? audioConsumer.rtpParameters : null"
               :video-rtp-parameters="videoConsumer ? videoConsumer.rtpParameters : null"
               :consumer-spatial-layers="
        videoConsumer ? videoConsumer.spatialLayers : null
      "
               :consumer-temporal-layers="
        videoConsumer ? videoConsumer.temporalLayers : null
      "
               :consumer-current-spatial-layer="
        videoConsumer ? videoConsumer.currentSpatialLayer : null
      "
               :consumer-current-temporal-layer="
        videoConsumer ? videoConsumer.currentTemporalLayer : null
      "
               :consumer-preferred-spatial-layer="
        videoConsumer ? videoConsumer.preferredSpatialLayer : null
      "
               :consumer-preferred-temporal-layer="
        videoConsumer ? videoConsumer.preferredTemporalLayer : null
      "
               :consumer-priority="videoConsumer ? videoConsumer.priority : null"
               :audio-track="audioConsumer ? audioConsumer.track : null"
               :video-track="videoConsumer ? videoConsumer.track : null"
               :audio-muted="audioMuted"
               :video-visible="videoVisible"
               :video-multi-layer="
        videoConsumer !== undefined &&
          videoConsumer &&
          videoConsumer.type !== 'simple'
      "
               :audio-codec="audioConsumer ? audioConsumer.codec : null"
               :video-codec="videoConsumer ? videoConsumer.codec : null"
               :audio-score="audioConsumer ? audioConsumer.score : null"
               :video-score="videoConsumer ? videoConsumer.score : null"
               :face-detection="faceDetection"
               @onChangeVideoPreferredLayers="onChangeVideoPreferredLayers"
               @onChangeMaxSendingSpatialLayer="onChangeMaxSendingSpatialLayer"
               @onChangeVideoPriority="onChangeVideoPriority"
               @onRequestKeyFrame="onRequestKeyFrame"
               @onStatsClick="onSetStatsPeerId"
               @onDisableShareClick="onDisableShare"
    />

  </div>
</template>

<script>
import PeerView from '../media/PeerView/PeerView'
import $ from 'jquery';
export default {
  components: { PeerView },
  props: {
    myScreenShare: {
      type:Boolean,
      required:true
    },
    screenShare: {
      type:Boolean,
      required:true
    },
    peer: {
      type: Object,
      required: true
    },
    roomClient: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statsList:[],
      fpsInterval: null,
      muted:false,
      fps:null,
      networkType:null
    }
  },
  computed: {

    getMeScreenCastProducer() {
      return this.$store.state.producers.find(x => x.type == 'share');
    },
    audioConsumer() {
      if(this.screenShare) {
        if (this.myScreenShare) {
          return null;
        }
      }

      const consumersArray = this.peer.consumers.map((consumerId) =>
        this.$store.state.consumers.find(
          (consumer) => consumer.id === consumerId
        )
      )

      if(this.screenShare)
      {
        if(this.myScreenShare) {
          return this.peer;
        }


        var len = this.$store.state.consumers
          .filter((x) => x.track.kind === 'audio' && x.appData != null && x.appData.share == true && x.appData.source == 'screen-audio').length;

        if(len > 0)
        {
          return this.$store.state.consumers
            .filter((x) => x.track.kind === 'audio' && x.appData != null && x.appData.share == true && x.appData.source == 'screen-audio')[len - 1];
        }

        return this.$store.state.consumers
          .find((x) => x.track.kind === 'audio' && x.appData != null && x.appData.share == true && x.appData.source == 'screen-audio');
      }
      else
      {
        return this.$store.state.consumers
          .find((x) => x.appData.peerId == this.peer.id && x.track.kind === 'audio')
      }

    },
    audioEnabled() {
      return (
        Boolean(this.audioConsumer) &&
        !this.audioConsumer.locallyPaused &&
        !this.audioConsumer.remotelyPaused
      )
    },
    videoVisible() {
      return (
        Boolean(this.videoConsumer) &&
        !this.videoConsumer.locallyPaused &&
        !this.videoConsumer.remotelyPaused
      )
    },
    videoConsumer() {
      if(this.screenShare) {
        if (this.myScreenShare) {
          return this.$store.state.producers.find(x => x.type == 'share');
        }
      }

      if(this.screenShare)
      {
        return this.$store.state.consumers
          .find((x) => x.appData.peerId == this.peer.id && x.track.kind === 'video' && x.appData != null && x.appData.share == true && x.appData.source == 'screen');
      }
      else
      {
        return this.$store.state.consumers
          .find((x) => x.appData.peerId == this.peer.id && x.track.kind === 'video' && (x.appData == null || x.appData.share == undefined || x.appData.share == null || x.appData.share == false));
      }

    },
    getConsumers() {
      return this.$store.state.consumers;
    },
    screenConsumer() {
      const consumersArray = this.peer.consumers.map((consumerId) =>
        this.$store.state.consumers.find(
          (consumer) => consumer.id === consumerId
        )
      )

      return consumersArray
        .filter((consumer) => !!consumer)
        .find((consumer) => consumer.track.kind === 'screen')
    },
    audioMuted() {
      return this.$store.state.me.audioMuted
    },
    faceDetection() {
      return this.$store.state.room.faceDetection
    }
  },
  created() {
    this.fpsInterval = setInterval(async () => {
      try {
        if(this.videoConsumer == null)
        {
          this.fps = null;
          return;
        }

        var stats = await this.roomClient.getConsumerLocalStats(this.videoConsumer.id);
        if(stats == null)
        {
          this.fps="low";
        }

        if(stats == undefined)
        {
          this.fps="undefined";
          return;
        }

        stats = Array.from(stats.values());
        this.statsList = stats;


        if(this.screenShare)
        {
          if(stats[6].framesPerSecond >= 4)
          {
            this.fps = "high";
          }
          else if (stats[6].framesPerSecond >= 2)
          {
            this.fps = "med";
          }
          else
          {
            this.fps = "low";
          }
        }
        else
        {
          var currentFps = 0;
          if(stats[6] != undefined && stats[6].framesPerSecond)
          {
            currentFps = stats[6].framesPerSecond;
          }
          else if(stats[5] != undefined && stats[5].framesPerSecond)
          {
            currentFps = stats[5].framesPerSecond;
          }

          if(currentFps >= 12)
          {
            this.fps = "high";
          }
          else if (currentFps >= 6)
          {
            this.fps = "med";
          }
          else
          {
            this.fps = "low";
          }
        }



        this.networkType = stats[4].networkType;
      }
      catch(e)
      {
        console.warn(e);
      }

      if (localStorage.getItem('mute-audio-' + this.peer.id, "1") != null)
      {
        //debugger;
        this.muteRemoteAudio();
      }
    },1000);

  },
  beforeDestroy() {
    clearInterval(this.fpsInterval);
  },
  methods: {
    fullScreen() {

      var requestVideo = null;
      if (this.screenShare)
      {
        requestVideo = $('#video-' + this.peer.id + "-s")[0]
      }
      else {
        requestVideo = $('#video-' + this.peer.id)[0]
      }

      if (requestVideo.webkitEnterFullScreen) {
        // Toggle fullscreen in Safari for iPad
        requestVideo.webkitEnterFullScreen();
      } else {
        requestVideo.requestFullScreen();
        // Toggle fullscreen for other OS / Devices / Browsers
      }

    },
    muteRemoteAudio() {
      try {
        var elem = document.getElementById('audio-' + this.peer.id);
        if(elem != null)
        {
          this.muted = true;
          elem.pause();
          localStorage.setItem('mute-audio-' + this.peer.id, "1");
        }
      }
      catch (e)
      {
        console.warn(e);
      }
    },
    toggleRemoteAudio() {
      try {
        var elem = document.getElementById('audio-' + this.peer.id);
        if(elem != null)
        {
          if(elem.paused)
          {
            this.muted = false;
            elem.play();
            localStorage.removeItem('mute-audio-' + this.peer.id);
          }
          else
          {
            this.muted = true;
            elem.pause();
            localStorage.setItem('mute-audio-' + this.peer.id, "1");
          }
        }
      }
      catch (e)
      {
        console.warn(e);
      }
    },
    onRequestKeyFrame() {
      this.roomClient.requestConsumerKeyFrame(this.videoConsumer.id)
    },
    onChangeVideoPreferredLayers(
      newPreferredSpatialLayer,
      newPreferredTemporalLayer
    ) {
      this.roomClient.setConsumerPreferredLayers(
        this.videoConsumer.id,
        newPreferredSpatialLayer,
        newPreferredTemporalLayer
      )
    },
    onChangeMaxSendingSpatialLayer(newMaxSpatialLayer) {
      this.roomClient.setConsumerPreferredLayers(
        this.videoConsumer.id,
        newMaxSpatialLayer,
        this.roomClient.temporalLayer
      )
    },
    onChangeVideoPriority(priority) {
      this.roomClient.setConsumerPriority(this.videoConsumer.id, priority)
    },
    onSetStatsPeerId(peerId) {
      this.$store.commit('RoomsetRoomStatsPeerId', { peerId })
    },
    onDisableShare() {
      this.roomClient.disableShare();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/Peer.vue